import React from "react";

import {
Box,
Typography,
Divider,
Paper,
Table,
TableBody,
TableCell,
TableContainer,
TableHead,
TableRow
} from "@mui/material";
import { Button } from "antd";

import {
School,
Person
} from "@mui/icons-material";

import testlogo from "./savationChristLogo.png";


// =================================
// HELPERS
// =================================

const formatValue = (value) => {

    if (
        value === null ||
        value === undefined ||
        value === ""
    ) {
        return "N/A";
    }

    return value;

};



const getScoreColor = (score) => {

    const value = Number(score);

    if (!isNaN(value) && value < 70) {
        return "red";
    }

    return "#001f5b";

};




// =================================mlfld
// COMPONENT START
// =================================

const ONScreenReportCard = ({
    reportCard,
    promotionChecks,
    handlePromotionCheckChange,
    selectedYear,
    handleDownloadStudentReportCard
}) => {


    if (!reportCard) {
        return null;
    }



    return (

        <Box
            id="onscreen-report-card"
            sx={{
                width:"100%",
                maxWidth:"1100px",
                margin:"auto",
                background:"#ffffff",
                padding:3,
                fontFamily:"Arial, Helvetica, sans-serif",
                color:"#222"
            }}
        >


            {/* =================================
                SCHOOL HEADER
            ================================= */}


            <Paper
                elevation={3}
                sx={{
                    padding:2,
                    mb:3,
                    border:"2px solid #001f5b"
                }}
            >

                <Box
                    sx={{
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:3
                    }}
                >


                    {/* LOGO + SCHOOL DETAILS */}

                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            gap:2
                        }}
                    >

                        <Box
                            component="img"
                            src={testlogo}
                            alt="School Logo"
                            sx={{
                                width:90,
                                height:90,
                                objectFit:"cover",
                                borderRadius:"50%",
                                border:"3px solid #001f5b"
                            }}
                        />


                        <Box>

                            <Typography
                                sx={{
                                    fontSize:22,
                                    fontWeight:"bold",
                                    color:"#001f5b"
                                }}
                            >
                                Salvation In Christ School System
                              
                            </Typography>


                            <Typography>
                                Zazay Community, Paynesville City, Monrovia
                             
                            </Typography>


                            <Typography
                                sx={{
                                    mt:1,
                                    fontWeight:"bold"
                                }}
                            >
                                Academic Year:{" "}
                                {formatValue(selectedYear?.name)}
                            </Typography>

                                <Button
                                    variant="contained"
                                    onClick={handleDownloadStudentReportCard}
                                >
                                    Download Student ReportCard
                                </Button>


                        </Box>


                    </Box>




                    {/* REPORT TITLE */}

                    <Box
                        sx={{
                            textAlign:"center"
                        }}
                    >

                        <Typography
                            sx={{
                                fontSize:30,
                                fontWeight:"bold",
                                color:"#001f5b"
                            }}
                        >
                            STUDENT PROGRESS REPORT
                        </Typography>


                        <Typography
                            sx={{
                                fontSize:15
                            }}
                        >
                            Academic Performance Record
                        </Typography>


                    </Box>



                </Box>


            </Paper>





            {/* =================================
                STUDENT INFORMATION
            ================================= */}


            <Paper
                elevation={2}
                sx={{
                    mb:3,
                    padding:2,
                    border:"1px solid #ddd"
                }}
            >


                <Box
                    sx={{
                        display:"flex",
                        alignItems:"center",
                        gap:1,
                        mb:2
                    }}
                >

                    <Person
                        sx={{
                            color:"#001f5b"
                        }}
                    />


                    <Typography
                        sx={{
                            fontWeight:"bold",
                            fontSize:18,
                            color:"#001f5b"
                        }}
                    >
                        Student Information
                    </Typography>


                </Box>


                <Divider
                    sx={{
                        mb:2
                    }}
                />



                <Box
                    sx={{
                        display:"grid",
                        gridTemplateColumns:{
                            xs:"1fr",
                            sm:"repeat(3,1fr)"
                        },
                        gap:2
                    }}
                >



                    <Box>

                        <Typography fontWeight="bold">
                            Student Name
                        </Typography>

                        <Typography>
                            {formatValue(reportCard.student_name)}
                        </Typography>

                    </Box>




                    <Box>

                        <Typography fontWeight="bold">
                            Grade Class
                        </Typography>

                        <Typography>
                            {formatValue(reportCard.grade_class_name)}
                        </Typography>

                    </Box>




                    <Box>

                        <Typography fontWeight="bold">
                            Student ID
                        </Typography>

                        <Typography>
                            {formatValue(reportCard.student_id)}
                        </Typography>

                    </Box>





                    <Box>

                        <Typography fontWeight="bold">
                            Academic Year
                        </Typography>

                        <Typography>
                            {formatValue(selectedYear?.name)}
                        </Typography>

                    </Box>





                    <Box>

                        <Typography fontWeight="bold">
                            Semester
                        </Typography>

                        <Typography>
                            Full Academic Year
                        </Typography>

                    </Box>





                    <Box>

                        <Typography fontWeight="bold">
                            Status
                        </Typography>

                        <Typography>
                            Active Student
                        </Typography>

                    </Box>



                </Box>



            </Paper>

            {/* =================================
                ACADEMIC PERFORMANCE TABLE
            ================================= */}


            <Paper
                elevation={2}
                sx={{
                    mb:3,
                    border:"1px solid #ddd"
                }}
            >


                <Box
                    sx={{
                        display:"flex",
                        alignItems:"center",
                        gap:1,
                        padding:2
                    }}
                >

                    <School
                        sx={{
                            color:"#001f5b"
                        }}
                    />


                    <Typography
                        sx={{
                            fontWeight:"bold",
                            fontSize:18,
                            color:"#001f5b"
                        }}
                    >
                        Academic Performance
                    </Typography>


                </Box>



                <Divider />



                <TableContainer
                    sx={{
                        overflowX:"auto"
                    }}
                >


                    <Table
                        size="small"
                        sx={{
                            minWidth:900
                        }}
                    >


                        <TableHead>


                            <TableRow
                                sx={{
                                    backgroundColor:"#001f5b"
                                }}
                            >


                                <TableCell
                                    sx={{
                                        color:"#fff",
                                        fontWeight:"bold"
                                    }}
                                >
                                    SUBJECT
                                </TableCell>


                                {
                                    [
                                        "Period 1",
                                        "Period 2",
                                        "Period 3",
                                        "Exam",
                                        "Period 4",
                                        "Period 5",
                                        "Period 6",
                                        "Exam2"
                                    ].map((period)=>(


                                        <TableCell
                                            key={period}
                                            align="center"
                                            sx={{
                                                color:"#fff",
                                                fontWeight:"bold"
                                            }}
                                        >
                                            {period}
                                        </TableCell>


                                    ))
                                }



                                <TableCell
                                    align="center"
                                    sx={{
                                        color:"#fff",
                                        fontWeight:"bold"
                                    }}
                                >
                                    YEAR AVG
                                </TableCell>



                            </TableRow>


                        </TableHead>





                        <TableBody>


                        {


                        reportCard.period_grades &&

                        [

                            ...new Set(

                                reportCard.period_grades.map(

                                    item=>item.subject_name

                                )

                            )

                        ]

                        .map((subject,index)=>{


                            const subjectGrades =

                            reportCard.period_grades.filter(

                                item=>item.subject_name===subject

                            );



                            const yearlyAverage =

                            reportCard.subjects_semester_averages?.find( 

                                item=>item.subject_name===subject

                            );





                            const periods = [

                                "Period 1",
                                "Period 2",
                                "Period 3",
                                "Exam",
                                "Period 4",
                                "Period 5",
                                "Period 6",
                                "Exam2"

                            ];



                            return (


                                <TableRow
                                    key={subject}
                                    sx={{
                                        backgroundColor:
                                        index % 2 === 0
                                        ?
                                        "#f8fafc"
                                        :
                                        "#ffffff"
                                    }}
                                >



                                    <TableCell
                                        sx={{
                                            fontWeight:"bold",
                                            color:"#001f5b"
                                        }}
                                    >
                                        {subject}
                                    </TableCell>





                                    {
                                    periods.map((period)=>(


                                        <TableCell
                                            key={period}
                                            align="center"
                                            sx={{
                                                fontWeight:"bold",
                                                color:

                                                getScoreColor(

                                                    subjectGrades.find(

                                                        item=>

                                                        item.period_name===period

                                                    )
                                                    ?.formatted_final_score

                                                )
                                            }}
                                        >


                                        {

                                        subjectGrades.find(

                                            item=>

                                            item.period_name===period

                                        )
                                        ?.formatted_final_score

                                        ||

                                        "-"

                                        }


                                        </TableCell>


                                    ))

                                    }





                                    <TableCell
                                        align="center"
                                        sx={{
                                            fontWeight:"bold",
                                            color:"#001f5b"
                                        }}
                                    >

                                    {

                                    yearlyAverage?.yearly_avg

                                    ||

                                    "-"

                                    }


                                    </TableCell>




                                </TableRow>


                            );


                        })


                        }



                        </TableBody>


                    </Table>


                </TableContainer>


            </Paper>







            {/* =================================
                SEMESTER SUMMARY
            ================================= */}



            <Paper
                elevation={2}
                sx={{
                    mb:3,
                    padding:2,
                    border:"1px solid #ddd"
                }}
            >



                <Typography
                    sx={{
                        fontWeight:"bold",
                        fontSize:18,
                        color:"#001f5b",
                        mb:2
                    }}
                >
                    Semester Summary
                </Typography>



                <Divider
                    sx={{
                        mb:2
                    }}
                />




                <Box
                    sx={{
                        display:"grid",
                        gridTemplateColumns:{
                            xs:"1fr",
                            sm:"repeat(3,1fr)"
                        },
                        gap:3
                    }}
                >



                    <Box
                        sx={{
                            textAlign:"center",
                            border:"1px solid #ddd",
                            padding:2
                        }}
                    >

                        <Typography fontWeight="bold">
                            Semester 1 Average
                        </Typography>


                        <Typography
                            sx={{
                                fontSize:25,
                                fontWeight:"bold",
                                color:"#001f5b"
                            }}
                        >

                            {

                            reportCard.semester_1_avg

                            ||

                            "N/A"

                            }

                        </Typography>


                    </Box>





                    <Box
                        sx={{
                            textAlign:"center",
                            border:"1px solid #ddd",
                            padding:2
                        }}
                    >

                        <Typography fontWeight="bold">
                            Semester 2 Average
                        </Typography>


                        <Typography
                            sx={{
                                fontSize:25,
                                fontWeight:"bold",
                                color:"#001f5b"
                            }}
                        >

                            {

                            reportCard.semester_2_avg

                            ||

                            "N/A"

                            }

                        </Typography>


                    </Box>





                    <Box
                        sx={{
                            textAlign:"center",
                            border:"1px solid #ddd",
                            padding:2
                        }}
                    >

                        <Typography fontWeight="bold">
                            Final Year Average
                        </Typography>


                        <Typography
                            sx={{
                                fontSize:25,
                                fontWeight:"bold",
                                color:"#001f5b"
                            }}
                        >

                            {

                            reportCard.yearly_average

                            ||

                            "N/A"

                            }

                        </Typography>


                    </Box>




                </Box>


            </Paper>






            {/* =================================
                OVERALL PERFORMANCE
            ================================= */



            <Paper
                elevation={2}
                sx={{
                    mb:3,
                    padding:2,
                    backgroundColor:"#f5f7fa",
                    border:"1px solid #ddd"
                }}
            >


                <Typography
                    sx={{
                        fontWeight:"bold",
                        fontSize:18,
                        color:"#001f5b",
                        mb:2
                    }}
                >
                    Overall Performance
                </Typography>



                <Divider
                    sx={{
                        mb:2
                    }}
                />




                <Box
                    sx={{
                        display:"grid",
                        gridTemplateColumns:{
                            xs:"1fr",
                            sm:"repeat(3,1fr)"
                        },
                        gap:2
                    }}
                >



                    <Box>

                        <Typography fontWeight="bold">
                            Total Subjects
                        </Typography>

                        <Typography>
                            {

                            reportCard.period_grades

                            ?

                            [

                            ...new Set(

                            reportCard.period_grades.map(

                            item=>item.subject_name

                            )

                            )

                            ].length

                            :

                            0

                            }

                        </Typography>


                    </Box>




                    <Box>

                        <Typography fontWeight="bold">
                            Class Rank
                        </Typography>

                        <Typography>
                            {

                            reportCard.rank

                            ||

                            "N/A"

                            }

                        </Typography>


                    </Box>




                    <Box>

                        <Typography fontWeight="bold">
                            Total Students
                        </Typography>

                        <Typography>
                            {

                            reportCard.total_students

                            ||

                            "N/A"

                            }

                        </Typography>


                    </Box>




                </Box>



            </Paper>

            /* =================================
                TEACHER REMARK
            ================================= *


            <Paper
                elevation={2}
                sx={{
                    mb:3,
                    padding:2,
                    backgroundColor:"#001f5b",
                    color:"#fff"
                }}
            >


                <Typography
                    sx={{
                        fontWeight:"bold",
                        fontSize:18,
                        mb:1
                    }}
                >
                    Teacher's Remark
                </Typography>



                <Divider
                    sx={{
                        backgroundColor:"rgba(255,255,255,0.5)",
                        mb:2
                    }}
                />



                <Typography
                    sx={{
                        fontSize:15,
                        lineHeight:1.7
                    }}
                >

                    {

                    reportCard.remark

                    ||

                    "No remarks available."

                    }


                </Typography>


            </Paper>







            {/* =================================
                GRADE LEGEND
            ================================= */}



            <Paper
                elevation={2}
                sx={{
                    mb:3,
                    padding:2,
                    border:"1px solid #ddd"
                }}
            >


                <Typography
                    sx={{
                        fontWeight:"bold",
                        fontSize:18,
                        color:"#001f5b",
                        mb:2
                    }}
                >
                    Grade Legend
                </Typography>



                <Divider
                    sx={{
                        mb:2
                    }}
                />



                <Box
                    sx={{
                        display:"grid",
                        gridTemplateColumns:{
                            xs:"1fr",
                            sm:"repeat(5,1fr)"
                        },
                        gap:2
                    }}
                >


                    <Box textAlign="center">
                        <Typography fontWeight="bold">
                            90 - 100
                        </Typography>

                        <Typography>
                            Principal List
                        </Typography>
                    </Box>




                    <Box textAlign="center">
                        <Typography fontWeight="bold">
                            86 - 89
                        </Typography>

                        <Typography>
                            High Honor
                        </Typography>
                    </Box>





                    <Box textAlign="center">
                        <Typography fontWeight="bold">
                            80 - 85
                        </Typography>

                        <Typography>
                            Honor Roll
                        </Typography>
                    </Box>





                    <Box textAlign="center">
                        <Typography fontWeight="bold">
                            70 - 79
                        </Typography>

                        <Typography>
                            Pass
                        </Typography>
                    </Box>





                    <Box textAlign="center">
                        <Typography fontWeight="bold">
                            Below 70
                        </Typography>

                        <Typography>
                            Fail
                        </Typography>
                    </Box>



                </Box>


            </Paper>







            {/* =================================
                PROMOTION DECISION
            ================================= */}



            <Paper
                elevation={2}
                sx={{
                    mb:3,
                    padding:2,
                    border:"1px solid #f0c36d",
                    backgroundColor:"#fff8e1"
                }}
            >







                <Divider
                    sx={{
                        mb:2
                    }}
                />




                <Box
                    sx={{
                        display:"flex",
                        gap:3,
                        flexWrap:"wrap"
                    }}
                >



                    <label>

                        <input
                            type="checkbox"
                            checked={
                                promotionChecks?.promoted || false
                            }
                            onChange={handlePromotionCheckChange}
                            name="promoted"
                        />

                        {" "}
                        Promoted

                    </label>





                    <label>

                        <input
                            type="checkbox"
                            checked={
                                promotionChecks?.condition || false
                            }
                            onChange={handlePromotionCheckChange}
                            name="condition"
                        />

                        {" "}
                        Promoted With Condition

                    </label>





                    <label>

                        <input
                            type="checkbox"
                            checked={
                                promotionChecks?.fail || false
                            }
                            onChange={handlePromotionCheckChange}
                            name="fail"
                        />

                        {" "}
                        Failed

                    </label>





                    <label>

                        <input
                            type="checkbox"
                            checked={
                                promotionChecks?.neverToReturn || false
                            }
                            onChange={handlePromotionCheckChange}
                            name="neverToReturn"
                        />

                        {" "}
                        Never To Return

                    </label>



                </Box>


            </Paper>








            {/* =================================
                ATTENDANCE AND CONDUCT
            ================================= */}



            <Paper
                elevation={2}
                sx={{
                    mb:3,
                    padding:2,
                    border:"1px solid #ddd"
                }}
            >


                <Typography
                    sx={{
                        fontWeight:"bold",
                        fontSize:18,
                        color:"#001f5b",
                        mb:2
                    }}
                >
                    Attendance & Conduct
                </Typography>



                <Divider
                    sx={{
                        mb:2
                    }}
                />



                <Box
                    sx={{
                        display:"grid",
                        gridTemplateColumns:{
                            xs:"1fr",
                            sm:"repeat(3,1fr)"
                        },
                        gap:2
                    }}
                >



                    <Box>

                        <Typography fontWeight="bold">
                            Attendance
                        </Typography>

                        <Typography>
                            {

                            reportCard.attendance

                            ||

                            "N/A"

                            }
                        </Typography>

                    </Box>




                    <Box>

                        <Typography fontWeight="bold">
                            Behavior
                        </Typography>

                        <Typography>
                            {

                            reportCard.behavior

                            ||

                            "Excellent"

                            }
                        </Typography>

                    </Box>





                    <Box>

                        <Typography fontWeight="bold">
                            Participation
                        </Typography>

                        <Typography>
                            {

                            reportCard.participation

                            ||

                            "Good"

                            }
                        </Typography>

                    </Box>



                </Box>



            </Paper>







            {/* =================================
                SIGNATURE SECTION
            ================================= */}



            <Paper
                elevation={2}
                sx={{
                    mb:3,
                    padding:3
                }}
            >
      </Paper>
           {/* =================================
                FOOTER
            ================================= */}



            <Box
                sx={{
                    textAlign:"center",
                    mt:4,
                    pb:3
                }}
            >


                <Typography
                    sx={{
                        fontWeight:"bold",
                        color:"#001f5b",
                        fontSize:18
                    }}
                >
                    Jana L. Williams Educational Foundation
                </Typography>



                <Typography
                    sx={{
                        color:"#555",
                        mt:1
                    }}
                >
                    Building Character • Inspiring Excellence • Creating Leaders
                </Typography>



            </Box>





        </Box>


    );


};




export default ONScreenReportCard;